import { useNavigate } from "react-router-dom";
import { useVisitDialog } from "./DialogContext";
import { VisitModalLayout } from "./VisitModalLayout";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";

VisitModalLayout.VisitFooter = function VisitFooter() {
  const { successView, accept, reject } = useVisitDialog();
  const navigate = useNavigate();

  if (successView) {
    return (
      <div className="pt-5 text-center">
        <GradientButton
          btnText="Ok"
          width="w-28"
          onClick={() => navigate("/complaint/visit-all")}
        />
      </div>
    );
  }

  if (accept && reject) {
    return (
      <div className="mt-3 gap-2 flex-center-align">
        <GradientButton btnText="Approve" onClick={accept} />
        <GrayButton btnText="Reject" onClick={reject} />
      </div>
    );
  }

  return null;
};
